export const TIPO_ARCHIVO_MAPEO = {
  FACTURAS: 'facturas',
  PROVEEDORES: 'proveedores',
  INFORMACION_BANCARIA: 'informacion-bancaria'
} as const;

export type TipoArchivoMapeo = typeof TIPO_ARCHIVO_MAPEO[keyof typeof TIPO_ARCHIVO_MAPEO];
